import { formatUsd } from "../../shared/money";
import type { PublicState } from "../../shared/types";

export function Stats({ state }: { state: PublicState }) {
  const holderSince = state.currentHolder
    ? new Intl.DateTimeFormat("en", { dateStyle: "medium", timeStyle: "short" }).format(
        state.currentHolder.currentPeriodStartedAt,
      )
    : "Nobody";
  return (
    <dl className="stats-grid">
      <div>
        <dt>CURRENT MINIMUM</dt>
        <dd>{formatUsd(state.currentPriceCents)}</dd>
      </div>
      <div>
        <dt>SUCCESSFUL PRESSES</dt>
        <dd>{state.successfulPressCount}</dd>
      </div>
      <div>
        <dt>NET PAID TO PRESS</dt>
        <dd>{formatUsd(state.netCapturedSubtotalCents)}</dd>
      </div>
      <div>
        <dt>CURRENT HOLDER SINCE</dt>
        <dd className="stat-date">{holderSince}</dd>
      </div>
    </dl>
  );
}
